export default __webpack_public_path__ + "static/media/hou-division.33d7abc7.jpg";